<template>
  <div class="card">
    <div class="d-none d-md-block">
      <div class="row event-row m-0 px-3 py-2">
        <div class="col-6 col-md-2 text-muted">Event Name</div>
        <div class="col-6 col-md-2 text-muted">Datum</div>
        <div class="col-12 col-md-4 text-muted">Kategorie</div>
        <div class="col-12 col-md-4 text-end text-muted">In den Warenkorb</div>
      </div>
    </div>
    <EventTableRow v-for="event in data.events" v-bind:key="event.id" v-bind:event="event"></EventTableRow>
  </div>
</template>

<script>
import EventTableRow from "@/components/EventTableRow";
export default {
  name: "EventGroupListItem",
  components: {EventTableRow},
  props: ["data"]
}
</script>

<style scoped>
.accordion-button:not(.collapsed) {
  color: #333333;
  background-color: rgba(0, 0, 0, 0.03);
}
.accordion-button:not(.collapsed)::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23333333'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
}
</style>